import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTour } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Tour';
import useUserStore from 'graph/state/query-hooks/use-user';
import { Settings } from 'types';

const AppLoadListeners: React.FC = (props) => {
  const navigate = useNavigate();
  const [user] = useUserStore();
  const [{ isTourInProgress }] = useTour();

  const shouldDisplayOnboardingModal = () => {
    const toursSettings = user?.me?.toursSettings;
    if (toursSettings && !toursSettings.length) return true;
    const onboardingTour = user?.me?.toursSettings?.find(
      (setting) => setting?.tour?.name === Settings.ONBOARDING
    );

    return onboardingTour?.tourStepSettings?.length;
  };

  useEffect(() => {
    const shouldShowTour = shouldDisplayOnboardingModal();
    if (user?.me?.toursSettings && !isTourInProgress && shouldShowTour)
      navigate({ pathname: '/tour/onboarding' });
  }, [user?.me?.toursSettings]);

  return <>{props.children}</>;
};

export default AppLoadListeners;
